 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"collection":"collection","collection-item":"collection-item","collection-item-list~dictionary~the-navigation-drawer~the-work-copy-snackbar~the-work-navigation-dra~bd1f8ebc":"collection-item-list~dictionary~the-navigation-drawer~the-work-copy-snackbar~the-work-navigation-dra~bd1f8ebc","collection-item-list~dictionary~the-navigation-drawer":"collection-item-list~dictionary~the-navigation-drawer","dictionary~the-work-navigation-drawer":"dictionary~the-work-navigation-drawer","dictionary":"dictionary","collection-item-list~the-navigation-drawer~work-read-online~work-table-of-contents":"collection-item-list~the-navigation-drawer~work-read-online~work-table-of-contents","the-navigation-drawer":"the-navigation-drawer","contact":"contact","legal":"legal","not-found":"not-found","section":"section","the-navigation-drawer-settings":"the-navigation-drawer-settings","work":"work","expansion-panels":"expansion-panels","collection-item-list":"collection-item-list","work-read-online":"work-read-online","work-actions":"work-actions","work-downloads":"work-downloads","work-info":"work-info","theme-changer":"theme-changer","the-work-copy-snackbar~the-work-navigation-drawer":"the-work-copy-snackbar~the-work-navigation-drawer","the-work-navigation-drawer":"the-work-navigation-drawer","the-work-copy-snackbar":"the-work-copy-snackbar","the-work-copy-selection":"the-work-copy-selection","the-work-note-footer":"the-work-note-footer","the-work-toc-footer":"the-work-toc-footer","collection-item-list-work-link":"collection-item-list-work-link","work-table-of-contents":"work-table-of-contents"}[chunkId]||chunkId) + "." + {"chunk-5160462c":"1dd93923","chunk-b6fcc4b8":"758de907","collection":"79793a22","collection-item":"f1ef5c85","collection-item-list~dictionary~the-navigation-drawer~the-work-copy-snackbar~the-work-navigation-dra~bd1f8ebc":"e916f5d3","collection-item-list~dictionary~the-navigation-drawer":"92af45d8","dictionary~the-work-navigation-drawer":"474034d8","dictionary":"7c4a238b","collection-item-list~the-navigation-drawer~work-read-online~work-table-of-contents":"5510d2fc","the-navigation-drawer":"589e237f","contact":"f33868a9","legal":"7eac34d2","not-found":"5ac6cfe5","section":"6d451249","the-navigation-drawer-settings":"43e37ae0","work":"2286816c","expansion-panels":"9f68d775","collection-item-list":"83ad7ceb","work-read-online":"edd8be42","work-actions":"4bc2fa8e","work-downloads":"ff641b5c","work-info":"7996bc98","theme-changer":"17e34429","the-work-copy-snackbar~the-work-navigation-drawer":"e797e142","the-work-navigation-drawer":"aed9e22b","the-work-copy-snackbar":"1ddfb557","the-work-copy-selection":"95aaf0ad","the-work-note-footer":"8c755bcd","the-work-toc-footer":"f4020f8e","collection-item-list-work-link":"4a5148cf","work-table-of-contents":"2873192f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-5160462c":1,"chunk-b6fcc4b8":1,"collection":1,"collection-item":1,"collection-item-list~dictionary~the-navigation-drawer~the-work-copy-snackbar~the-work-navigation-dra~bd1f8ebc":1,"collection-item-list~dictionary~the-navigation-drawer":1,"dictionary~the-work-navigation-drawer":1,"dictionary":1,"collection-item-list~the-navigation-drawer~work-read-online~work-table-of-contents":1,"the-navigation-drawer":1,"contact":1,"legal":1,"not-found":1,"the-navigation-drawer-settings":1,"work":1,"expansion-panels":1,"collection-item-list":1,"work-read-online":1,"work-info":1,"theme-changer":1,"the-work-copy-snackbar~the-work-navigation-drawer":1,"the-work-navigation-drawer":1,"the-work-note-footer":1,"the-work-toc-footer":1,"collection-item-list-work-link":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"collection":"collection","collection-item":"collection-item","collection-item-list~dictionary~the-navigation-drawer~the-work-copy-snackbar~the-work-navigation-dra~bd1f8ebc":"collection-item-list~dictionary~the-navigation-drawer~the-work-copy-snackbar~the-work-navigation-dra~bd1f8ebc","collection-item-list~dictionary~the-navigation-drawer":"collection-item-list~dictionary~the-navigation-drawer","dictionary~the-work-navigation-drawer":"dictionary~the-work-navigation-drawer","dictionary":"dictionary","collection-item-list~the-navigation-drawer~work-read-online~work-table-of-contents":"collection-item-list~the-navigation-drawer~work-read-online~work-table-of-contents","the-navigation-drawer":"the-navigation-drawer","contact":"contact","legal":"legal","not-found":"not-found","section":"section","the-navigation-drawer-settings":"the-navigation-drawer-settings","work":"work","expansion-panels":"expansion-panels","collection-item-list":"collection-item-list","work-read-online":"work-read-online","work-actions":"work-actions","work-downloads":"work-downloads","work-info":"work-info","theme-changer":"theme-changer","the-work-copy-snackbar~the-work-navigation-drawer":"the-work-copy-snackbar~the-work-navigation-drawer","the-work-navigation-drawer":"the-work-navigation-drawer","the-work-copy-snackbar":"the-work-copy-snackbar","the-work-copy-selection":"the-work-copy-selection","the-work-note-footer":"the-work-note-footer","the-work-toc-footer":"the-work-toc-footer","collection-item-list-work-link":"collection-item-list-work-link","work-table-of-contents":"work-table-of-contents"}[chunkId]||chunkId) + "." + {"chunk-5160462c":"f13166bd","chunk-b6fcc4b8":"a3ebaf9b","collection":"a7939b37","collection-item":"f5391fe1","collection-item-list~dictionary~the-navigation-drawer~the-work-copy-snackbar~the-work-navigation-dra~bd1f8ebc":"964af16c","collection-item-list~dictionary~the-navigation-drawer":"d083ae6e","dictionary~the-work-navigation-drawer":"57805b4d","dictionary":"e62f5b46","collection-item-list~the-navigation-drawer~work-read-online~work-table-of-contents":"cb3f84ff","the-navigation-drawer":"c6c8296f","contact":"5b6687a2","legal":"1caa847b","not-found":"df9d9a7c","section":"31d6cfe0","the-navigation-drawer-settings":"ed371b85","work":"1840b2a2","expansion-panels":"d766bf1c","collection-item-list":"7e45a9d3","work-read-online":"950381b3","work-actions":"31d6cfe0","work-downloads":"31d6cfe0","work-info":"96b995f8","theme-changer":"686b103a","the-work-copy-snackbar~the-work-navigation-drawer":"950381b3","the-work-navigation-drawer":"c6c8296f","the-work-copy-snackbar":"31d6cfe0","the-work-copy-selection":"31d6cfe0","the-work-note-footer":"860793e8","the-work-toc-footer":"d8221bba","collection-item-list-work-link":"dabab742","work-table-of-contents":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
